/**
 * 2018-04-16
 * Sirve para manejar los tabs de las vistas detalle
 */
import { Injectable } from '@angular/core';

export class DetalleNombre {
    public static readonly DETALLE_PROSPECTO: string = 'DETALLE_PROSPECTO';
    public static readonly DETALLE_CONTACTO: string = 'DETALLE_CONTACTO';
    public static readonly DETALLE_COTIZACION: string = 'DETALLE_COTIZACION';
    public static readonly DETALLE_INCIDENCIA: string = 'DETALLE_INCIDENCIA';
    public static readonly DETALLE_PRODUCTO: string = 'DETALLE_PRODUCTO';
    public static readonly DETALLE_CLIENTE: string = 'DETALLE_CLIENTE';
    public static readonly DETALLE_TAREA: string = 'DETALLE_TAREA';
    public static readonly DETALLE_NOTICIA: string = 'DETALLE_NOTICIA';
}

@Injectable()
export class DetalleService {
    constructor() { }

    /**
     * Set tab activo de la vista como el tab inicial o cero
     * @param detalleNombre vista detalle de la que se quiere recetear el tab activo
     */
    reiniciarTabDetalle(detalleNombre: string): void {
        localStorage.setItem(detalleNombre, "0");
    }

    /**
     * Set tab activo de la vista como el tab recibido por parametro
     * @param detalleNombre vista detalle de la que se quiere setear el tab activo
     * @param tabActivo numero de tab activo nuevo
     */
    setDetalleTabActivo(detalleNombre: string, tabActivo: number): void {
        localStorage.setItem(detalleNombre, tabActivo.toString());
    }

    /**
     * Retorna el tab actualmente activo de la vista detalle
     * @param detalleNombre vista detalle de la que se quiere obtener el tab activo
     */
    getDetalleTabActivo(detalleNombre: string): number {
        return parseInt(localStorage.getItem(detalleNombre)) || 0;
    }
}
